import { useWatch } from "react-hook-form";
import { useArtworkForm, useArtwork } from "@design-lab/entities/artwork";
import { useCompositionForm, useCurrentComposition } from "@design-lab/entities/composition";
import { useVisitedTabs } from "./useVisitedTabs";

export function useValidation() {
  const { form: artworkForm } = useArtworkForm();
  const artworkFormValues = useWatch({ control: artworkForm.control });
  const { form: compositionForm } = useCompositionForm();
  const compositionFormValues = useWatch({ control: compositionForm.control });
  const { front, back, someArtworkLoading } = useArtwork();
  const { currentComposition } = useCurrentComposition();

  const [visitedTabs] = useVisitedTabs();

  const frontLoadingStatus = front.state.hasTag("loading");
  const isFrontArtworkProcessing = Boolean(frontLoadingStatus);
  const isFrontArtworkUploaded = Boolean(
    artworkFormValues?.front?.artworkId || artworkFormValues?.frontLeftChest?.artworkId
  );

  const backLoadingStatus = back.state.hasTag("loading");
  const isBackArtworkProcessing = Boolean(backLoadingStatus);
  const isBackArtworkUploaded = Boolean(artworkFormValues?.back?.artworkId);

  const isArtworkUploaded = isFrontArtworkUploaded || isBackArtworkUploaded;

  const addedCompositions = compositionFormValues?.addedCompositions ?? [];
  const currentAddedComposition = addedCompositions.find(
    composition => composition.id === currentComposition?.id
  );

  const isQuantityValid = Object.values(currentAddedComposition?.variants || {}).some(
    quantity => Number(quantity) > 0
  );

  const isAllQuantitiesValid =
    compositionFormValues?.addedCompositions?.some(composition =>
      Object.values(composition.variants || {}).some(quantity => Number(quantity) > 0)
    ) || false;

  const isAtLeastOneArtworkProcessed =
    isArtworkUploaded && (!isFrontArtworkProcessing || !isBackArtworkProcessing);

  const isFileSelected = Boolean(
    front.state.context.visitedStates.includes("progress") ||
      front.state.matches("finished") ||
      back.state.context.visitedStates.includes("progress") ||
      back.state.matches("finished")
  );

  const isDesignTabsVisited =
    (artworkFormValues?.front?.artworkId || artworkFormValues?.frontLeftChest?.artworkId
      ? visitedTabs.has("front")
      : true) && (artworkFormValues?.back?.artworkId ? visitedTabs.has("back") : true);

  return {
    isFileSelected,
    isArtworkUploaded,
    isQuantityValid,
    isAllQuantitiesValid,
    isAtLeastOneArtworkProcessed,
    isSomeArtworkLoading: someArtworkLoading,
    isFrontArtworkUploaded,
    isBackArtworkUploaded,
    visitedTabs,
    isDesignTabsVisited
  };
}
